import { network } from 'services/network';

import { QueryParams } from 'api/queries/getBoardInit.query';

export const getBoardInit = (params: QueryParams) => {
    const url = `api/bo/getBoardInit?metaDataId=${params.metaDataId}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
